<template>
    <div class="view">
        <headers title='查看作品'></headers>
        <div class="tab">
            <div class="item"
                 :class="active_class==index?'active':''"
                 @click="change_tab(index)"
                 v-for="(item,index) in sf_class"
                 :key="index">{{item.unit_name}}</div>
        </div>
        <div class="list"
             v-if="list.length">
            <div class="item"
                 @click="choose_stu(item)"
                 v-for="(item,index) in list"
                 :key="index">
                <div class="pic">
                    <img :src="FILE_VIEW_URLROOT+'/'+item.img"
                         v-if="item.img"
                         class="img" />
                </div>
                <img :src="item.active==1?require('./img/icon_select.png'):require('./img/icon_unchecked2.png')"
                     v-if="item.active!=-1"
                     class="icon" />
                <p>{{item.real_name}}</p>
            </div>
        </div>
        <noResouse v-else></noResouse>
        <div class="footer">
            <span v-if="flag"
                  class="cancel"
                  @click="cancel">取消</span>
            <span class="share"
                  :class="!choose_stu_num&&flag?'gray':''"
                  @click="share">分享优秀作品</span>
        </div>
    </div>
</template>

<script>
import headers from 'COMPONENTS/base/header.vue'
import noResouse from 'COMPONENTS/noResouse.vue'
export default {
    components: {
        headers, noResouse
    },
    data () {
        return {
            FILE_VIEW_URLROOT: FILE_VIEW_URLROOT,
            cid: this.$route.params.cid,
            chapter_name: decodeURIComponent(this.$route.query.chapter_name),
            sf_class: [],//书法班级
            active_class: 0,
            flag: false,
            list: [],
            choose_stu_num: 0,
        }
    },
    created () {
        //先获取所有班级
        let all_class = JSON.parse(localStorage.getItem('info')).units
        //过滤出书法班级
        this.sf_class = all_class.filter(item => item.sid == 11 || item.sid == 14)
        this.getImgList(this.sf_class[this.active_class].unit_class_id)
    },
    methods: {
        getImgList (unit_class_id) {
            this.$http.post(API_URL_TASK_API + '/szyz/sf/look_units_works', {
                cid: this.cid,
                unit_class_id: unit_class_id
            }).then((res) => {
                if (res.data.response === 'ok') {
                    res.data.data.forEach(e => {
                        e.active = -1
                    })
                    this.list = res.data.data
                }
            })
        },
        change_tab (index) {
            this.active_class = index
            this.cancel()
            this.getImgList(this.sf_class[this.active_class].unit_class_id)
        },
        share () {
            let that = this
            if (!this.flag) {
                this.flag = true
                this.list.forEach(e => {
                    e.active = 0
                })
            } else {
                let _arr = []
                this.list.forEach(e => {
                    if (e.active == true) {
                        _arr.push(e.user_id)
                    }
                })
                if (!_arr.length) {
                    layer.tips('请选择学生');
                    return
                }
                console.log(_arr)
                //请求接口获取分享id
                this.$http.post(API_URL_TASK_API + '/szyz/sf/share_good_works', {
                    cid: this.cid,
                    stu_ids: JSON.stringify(_arr),
                }).then((res) => {
                    if (res.data.response === 'ok') {
                        let share_url = `${VUE_URL_HD}#/active/2023sfhd/result/${res.data.data}?cid=${this.cid}&grade_id=${this.sf_class[this.active_class].grade_id}&unit_name=${this.sf_class[this.active_class].unit_name}&chapter=${this.chapter_name}`
                        //请求接口生成短链
                        this.$http.post(API_URL_SORT_API + '/create_sort/', {
                            url: share_url,
                            sort_type: 2
                        }).then((resp) => {
                            if (resp.data.response === 'ok') {
                                this.cancel()
                                let short_url = resp.data.data.short_url
                                let coptText = `${this.sf_class[this.active_class].unit_name}的各位家长好，本次作业的优秀书法作品已选出，点击链接即可查看，链接：${short_url}`
                                layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                                    that.copyText(coptText);
                                    layer.close(index)
                                }, '分享链接复制成功')
                            }
                        })


                    }
                })
            }

        },
        cancel () {
            this.choose_stu_num = 0
            this.flag = false
            this.list.forEach(e => {
                e.active = -1
            })
        },
        choose_stu (item) {
            if (item.active == -1) {
                return
            } else {
                if (item.active == 0) {
                    this.choose_stu_num++
                    item.active = 1
                } else {
                    item.active = 0
                    this.choose_stu_num--
                }
            }
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    }
}
</script>

<style lang="scss" scoped>
.view {
    background: #fff;
    min-height: calc(100vh - 3.2rem);
    padding-bottom: 129px / $ppr;
}
.tab {
    margin-bottom: 10px / $ppr;
    .item {
        display: inline-block;
        font-size: 26px / $ppr;
        color: #999;
        margin: 0 24px / $ppr;
        padding: 24px / $ppr 0 12px / $ppr;
        &:after {
            content: "";
            width: 0;
            height: 6px / $ppr;
            background: #5e89ef;
            border-radius: 6px / $ppr;
            margin: 10px / $ppr auto 0;
            display: block;
        }
        &.active {
            font-size: 30px / $ppr;
            color: #000;
            &:after {
                width: 48px / $ppr;
            }
        }
    }
}
.list {
    padding: 0 24px / $ppr;
    margin-left: -1%;
    .item {
        display: inline-block;
        vertical-align: top;
        width: 49%;
        margin-left: 1%;
        margin-bottom: 24px / $ppr;
        position: relative;
        .icon {
            width: 40px / $ppr;
            height: 40px / $ppr;
            position: absolute;
            right: 0;
            top: 0;
        }
        .pic {
            display: block;
            width: 100%;
            max-block-size: 300px / $ppr;
            margin-bottom: 10px / $ppr;
            height: 300px / $ppr;
            overflow: hidden;

            img {
                width: 100%; /* 图片宽度占满容器 */
                height: 100%; /* 图片高度占满容器 */
                object-fit: cover; /* 按比例放大/缩小图片，使其完全覆盖容器 */
            }
        }
        p {
            font-size: 24px / $ppr;
            color: #666;
            text-align: center;
        }
    }
}
.footer {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    padding: 24px / $ppr;
    border-top: 1px / $ppr solid #e8e8e8;
    .cancel {
        padding: 0 77px / $ppr 0 53px / $ppr;
        line-height: 80px / $ppr;
        color: #5e89ef;
    }
    .share {
        line-height: 80px / $ppr;
        background: #5e89ef;
        color: #fff;
        border-radius: 80px / $ppr;
        flex: 1;
        text-align: center;
        &.gray {
            background: #bfbfbf;
        }
    }
}
</style>